const getPasswordStrengthIndicators = (score: number) => {
    let color = "bg-plum-500";
    let label = "Weak";

    if (score > 33) {
        color = "bg-mustard-300";
        label = "Moderate";
    }

    if (score === 100) {
        color = "bg-mint-300";
        label = "Strong";
    }

    return {
        color,
        label,
    };
};

export default getPasswordStrengthIndicators;
